import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { BarChart3, Loader } from 'lucide-react';
import { rawColors } from "../design-system/tokens/colors";

const ProgressBorderContainer = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
  z-index: 10;
`;

const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${props => props.progress}%;
  background: linear-gradient(90deg, #ff6b9d, #8b5cf6);
  transition: width 0.3s ease;
  border-radius: 2px;
`;

const ProgressContent = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(15, 15, 35, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: ${rawColors.text.white};
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 11;
`;

const ProgressText = styled.span`
  font-weight: 500;
`;

const SpinningLoader = styled.div`
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

interface AnalysisProgressBorderProps {
  progress: number;
  isVisible: boolean;
  currentStep?: string;
}

const AnalysisProgressBorder: React.FC<AnalysisProgressBorderProps> = ({
  progress,
  isVisible,
  currentStep
}) => {
  if (!isVisible) return null;

  return (
    <ProgressBorderContainer
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      {/* <ProgressText>{progress}%</ProgressText> */}
      <ProgressFill progress={progress} />
      <ProgressContent>
        <BarChart3 size={14} />
        <ProgressText>
          Analysis Progress: {progress}%
        </ProgressText>
        {currentStep && (
          <>
            <SpinningLoader>
              <Loader size={12} />
            </SpinningLoader>
            <span style={{ opacity: 0.7 }}>
              {currentStep}
            </span>
          </>
        )}
      </ProgressContent>
    </ProgressBorderContainer>
  );
};

export default AnalysisProgressBorder;
